/** 站点可选语言（与 i18n 资源文件名一致） */
export const APP_LOCALES = ['zh_CN', 'zh_TW', 'en_US', 'ja_JP', 'ko_KR'] as const

export type AppLocale = (typeof APP_LOCALES)[number]

export function isAppLocale(s: string): s is AppLocale {
  return (APP_LOCALES as readonly string[]).includes(s)
}

/** 语言下拉展示名 */
export const LOCALE_LABELS: Record<AppLocale, string> = {
  zh_CN: '中文',
  zh_TW: '繁體中文',
  en_US: 'English',
  ja_JP: '日本語',
  ko_KR: '한국어',
}

/** document.documentElement.lang（BCP 47） */
export const LOCALE_TO_HTML_LANG: Record<AppLocale, string> = {
  zh_CN: 'zh-CN',
  zh_TW: 'zh-TW',
  en_US: 'en-US',
  ja_JP: 'ja-JP',
  ko_KR: 'ko-KR',
}

/**
 * 接口 langExt 等多语字段目前多为 zh / en / ja；
 * 繁体沿用 zh；韩文无独立槽位时用 en。
 */
export const LOCALE_TO_API_LANGEXT: Record<AppLocale, 'zh' | 'en' | 'ja'> = {
  zh_CN: 'zh',
  zh_TW: 'zh',
  en_US: 'en',
  ja_JP: 'ja',
  ko_KR: 'en',
}

/** Manus 嵌入页仅支持 zh / ja / en */
export const LOCALE_TO_MANUS_LANG: Record<AppLocale, 'zh' | 'ja' | 'en'> = {
  zh_CN: 'zh',
  zh_TW: 'zh',
  en_US: 'en',
  ja_JP: 'ja',
  ko_KR: 'en',
}

/** Manus 主题类目页 ?lang=（manus.computer 主题站） */
export const LOCALE_TO_MANUS_THEME_LANG: Record<AppLocale, string> = {
  zh_CN: 'zh-CN',
  zh_TW: 'zh-TW',
  en_US: 'en',
  ja_JP: 'ja',
  ko_KR: 'ko',
}

/** AI Trip 嵌入 iframe ?lang=（与上表取值一致：zh-CN / zh-TW / en / ja / ko） */
export const LOCALE_TO_AI_TRIP_IFRAME_LANG = LOCALE_TO_MANUS_THEME_LANG
